import type { PersonSummary } from "~/types/global";

/**
 * Type guard that checks if a value is a PersonSummary object.
 * A PersonSummary must have an `executive_summary` string and a `topics` array.
 */
export function isPersonSummary(value: unknown): value is PersonSummary {
    return (
        typeof value === "object" &&
        value !== null &&
        "executive_summary" in value &&
        typeof (value as any).executive_summary === "string" &&
        "topics" in value &&
        Array.isArray((value as any).topics)
    );
}

/**
 * Type guard that checks if a summary_by_section record uses the nested
 * PersonSummary format (as opposed to the flat Record<string, string> format).
 * Checks the first value in the record to determine the format.
 */
export function isNestedSummaryBySection(
    summaryBySection: Record<string, string | PersonSummary>
): summaryBySection is Record<string, PersonSummary> {
    const values = Object.values(summaryBySection);
    if (values.length === 0) return false;
    return isPersonSummary(values[0]);
}
